export default function formatDateString(dateString: string) {
    if (dateString.length !== 10) {
        return dateString;
    }
    const [month, day, year] = dateString.split("/");
    return `${year}-${month}-${day}`;
}
